<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <!-- 查询 -->
    <div class="search-area" style="margin:0px">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">变更人：</div>
          <el-input size="mini" v-model="page.staffKey" class="ipt-sty" placeholder="请输入姓名/手机号" clearable></el-input
        ></el-col>
        <el-col :span="6">
          <div class="search-area-div w110">变更时间：</div>
          <el-date-picker
            class="w68f"
            size="mini"
            v-model="timeList"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            placeholder="选择时间"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">变更方式：</div>
          <el-select size="mini" v-model="page.operateType" placeholder="请选择" class="ipt-sty" clearable>
            <el-option v-for="item in logState" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" style="padding-right:10px">
          <el-button size="mini" type="info" @click="getData(true)" v-preventReClick="3000">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15">
        <el-col :span="6"
          ><div class="search-area-div">变更内容：</div>
          <el-input
            size="mini"
            v-model="page.alterFieldContent"
            class="ipt-sty"
            placeholder="请输入变更的字段"
            clearable
          ></el-input
        ></el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    page:{ // 人员组织列表
      type: Object,
      default: {},
    },
    // list:{ // 人员组织列表
    //   type: Array,
    //   default: [],
    // }
  },
  data() {
    return {
      customerName: '',
      logState: [
        { value: null, label: '全部' },
        { value: 1, label: '新增资料' },
        { value: 2, label: '变更基础资料' },
        { value: 3, label: '删除资料' },
        { value: 4, label: '导入资料' },
        { value: 5, label: '指派人员' },
        { value: 6, label: '等级变更' },
        // { value: 7, label: '业务员自行指派' },
        { value: 7, label: '数据清洗导入' },
      ],
      timeList: [],
      tableData: [],
      tableLoading: false,
      fullscreenLoading: false,
    };
  },
  created() {
  },
  methods: {
    empty() {
      this.timeList = []
      this.$emit('empty','empty')
    },
    //列表
    getData(flg) {
      this.$emit('getData',{timeList:this.timeList,flg})
    },
  },
};
</script>
<style scoped>
/* 标题 */
.page-title-box {
  height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  background: #ffffff;
  border-bottom: 1px solid #d9d9d9;
}
.page-back {
  width: 60px;
  height: 28px;
  line-height: 28px;
  border-radius: 2px;
  cursor: pointer;
  border: 1px solid #d9d9d9;
}
.page-title {
  flex: 1;
  font-size: 16px;
  text-align: center;
}
/* 内容 */
.page-content-box {
  padding: 16px;
  margin-top: 8px;
  background: #fff;
  box-sizing: border-box;
}
.filling-list-title {
  height: 32px;
  line-height: 32px;
  display: flex;
  font-size: 12px;
  text-align: left;
  border-bottom: 1px solid #d9d9d9;
  background: #f2f2f2;
}
.page-title-item {
  padding-left: 12px;
  border-right: 1px solid #d9d9d9;
}
.page-title-item:nth-child(1),
.page-title-item:nth-child(3) {
  width: 230px;
}
.page-title-item:nth-child(2) {
  flex: 1;
}

.filling-content-list {
  display: flex;
  padding: 16px 0;
  text-align: left;
  box-sizing: border-box;
  border-left: 1px solid #d9d9d9;
  border-right: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
}
.filling-content-date,
.filling-content-detail {
  flex-shrink: 0;
  width: 230px;
  padding-left: 12px;
}
.filling-content-date {
  color: #666666;
}
.filling-content-detail {
  color: #4fa1a4;
}
.filling-content-detail span {
  cursor: pointer;
}
.filling-content-txt {
  flex: 1;
  padding-left: 12px;
}
.filling-txt-title {
  font-size: 16px;
  color: #404040;
  margin-bottom: 10px;
}
.filling-content-txt p {
  font-size: 14px;
  color: #666666;
  line-height: 21px;
  margin: 3px 0;
}
.filling-content-txt p span {
  flex-shrink: 0;
}
.no-data {
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.el-col-6 {
  display: flex;
}
.search-area-div {
  min-width: 100px;
  text-align: right;
}
</style>
